// extracted by mini-css-extract-plugin
export default {"tooltipInfoText":"info-popover__tooltipInfoText","infoTooltipContainter":"info-popover__infoTooltipContainter","infoButton":"info-popover__infoButton"};